/**
 * SAP CONFIDENTIAL 
 *
 * This software is confidential proprietary software licensed by SAP SE 
 * and is not to be used, duplicated or disclosed to anyone without the 
 * prior written permission of SAP. 
 *
 * (C) 2020 Copyright SAP SE.
 */
import { Component, OnInit, Output, EventEmitter, AfterViewInit } from '@angular/core';
import { CommonService } from '../../shared/services/common.service';
import { MODULE_NAME_CODES } from '../../config/constants';
import { TranslateService } from '@ngx-translate/core';
import { BsModalService } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-bookmarks',
  templateUrl: './bookmarks.component.html'
})
export class BookmarksComponent implements OnInit, AfterViewInit {
  @Output() closeSlider: EventEmitter<any> = new EventEmitter();
  public card: any = {};
  public homeMetaData: { modules: Array<any> } = { modules : []};
  public sort: any = {
    'bookmark': true
  };
  public bookmarkCard = {};
  public validationObj = {
    userMessage: '',
    state: ''
  };

  constructor( public modalService: BsModalService,
    private commonService: CommonService,
    private translate: TranslateService) {
    const vm = this;
    const menuId = this.commonService.getMenuId('BKM');
      this.commonService.setHelpObj({
        header:this.getTranslationWithKey('BKM') || '',
        menuId: menuId,
        sections: [],
        lastSavedData: [],
        tools: [
          {
            icon: 'icon-edit',
            action: this.getTranslationWithKey('edit'),
            actionInfo:this.getTranslationWithKey('edit_info')
          }, {
            icon: 'icon-share-2',
            action: this.getTranslationWithKey('share'),
            actionInfo:this.getTranslationWithKey('share_info')
          }, {
            icon: 'icon-delete',
            action: this.getTranslationWithKey('delete'),
            actionInfo:this.getTranslationWithKey('delete_info')
          }
        ],
        relatedLinks: [
          {
            label: this.getTranslationWithKey('FLP'),
            url: '/fieldsupport/distributorList/default'
          }, {
            label: this.getTranslationWithKey('GLY'),
            url: '/genealogyHome/genealogy/default'
          }, {
            label: this.getTranslationWithKey('ALT'),
            url: '/compensationHome/compensationAnalytics/default'
          }
        ]
      });
        vm.card = {
          code: 'BSC',
          name: this.getTranslationWithKey('bookmarks'),
          icon: "icon-favorite-list",
          showCloseIcon: true,
          showSearchBox: false,
          filter: this.getTranslationWithKey('bookmarks_filter'),
          filterVal: '',
          recentSort: true,
          noDataMsg: this.getTranslationWithKey('no_bookmarks_message')+ `<em class='icon-favorite-list' style='color:#2797df;'></em>`+ this.getTranslationWithKey('icon_share'),
          items: [{
              name: this.getTranslationWithKey('salesforce'),
              code: MODULE_NAME_CODES.Distributors,
              collapse: false,
              list: []
          }, {
              name: this.getTranslationWithKey('lineage'),
              code: MODULE_NAME_CODES.Genealogies,
              collapse: false,
              list: []
          }, {
              name: this.getTranslationWithKey('reports'),
              code: MODULE_NAME_CODES.Reports,
              collapse: false,
              list: []
          }, {
              name: this.getTranslationWithKey('shared_with_me'),
              collapse: false,
              list: []
          } ]
      };
  }

  ngOnInit() {
    this.homeMetaData = this.commonService.getHomeMetaDetails();
  }

  ngAfterViewInit() {}

  public getTranslationWithKey(key: string) {
    return this.commonService.getTranslatedVal(key);
  }

  public closeSliderTriggered() {
    this.closeSlider.emit();
  }
}
